import { useEffect } from 'react'
import { useStoreState, useStoreActions } from '@mortgage-pos/ui/store'

export const useFetchLoanOfficer = () => {
  const { loanOfficer } = useStoreState((state) => state.loanOfficer)
  const { bankrateLeadId } = useStoreState((state) => state.questionnaire)

  const { getLoanOfficer } = useStoreActions((state) => state.loanOfficer)

  useEffect(() => {
    async function getAssignedLoanOfficer() {
      await getLoanOfficer()
    }

    if (bankrateLeadId && !loanOfficer) {
      getAssignedLoanOfficer()
    }
  }, [bankrateLeadId])
}

export default useFetchLoanOfficer
